import { useIntl } from "react-intl"
import { useState } from "react"
import { Button } from "primereact/button"
import { classNames } from "primereact/utils"
import './Budget.scss'
import { BudgetDTO } from "../../dto/budget/BudgetDTO"
import { EBudgetGridOptions, EBudgetGridOptionsValues } from "../../enums/EBudgetGridOptions"
import { ButtonOverlay, Combobox, TableButton, formatDate, getDate } from "medere-ui-framework"
import BudgetTable from "./tables/BudgetTable"
import { ComboDataDTO } from "../../dto/ComboDataDTO"
import { changeBudgetState, getBudgetStates } from "../../servicesHooks/Budget/useBudgetService"
import DuplicateBudgetModal from "./DuplicateBudgetModal"

interface BudgetPreviewProps {
    setSelectedAction: (action:number) => void;
    selectedBudget: BudgetDTO;
    setSelectedBudget: (selectedBudget:BudgetDTO) => void;
    setOpenPrintBudgetModal: (value:boolean) => void;
}

const ViewModes = {
    CLIENT: 1,
    BUSINESS: 2
};
export default function BudgetPreview({setSelectedAction,selectedBudget, setSelectedBudget, setOpenPrintBudgetModal}:BudgetPreviewProps) {

    const intl = useIntl();
    const [viewMode, setViewMode] = useState<number>(ViewModes.CLIENT);

    const [openDuplicateBudgetModal, setOpenDuplicateBudgetModal] = useState<boolean>(false); 

    function onDuplicateBudget(budget:BudgetDTO){
        setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]);
        setSelectedBudget(budget);
    }

    return (
        <div className='min-h-screen flex-column mb-5'>
            <Button label="< Volver" className="linkButton" onClick={() => setSelectedAction(-1)} />
            <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
                <h2 className="text-2xl mainTitle">
                    {intl.formatMessage({ id: 'Budgets-Preview' })}
                </h2>
            </div>
            <div className="flex justify-content-between">
                <ul className="p-0 m-0 list-none flex overflow-x-auto select-none w-full">
                    {<li style={{backgroundColor:'#f9fafb'}}>
                        <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150    border-noround', { 'tabComponent': viewMode == ViewModes.CLIENT, 'text-700 border-transparent': viewMode != ViewModes.CLIENT })} onClick={() => setViewMode(ViewModes.CLIENT)}>
                            <span className="font-medium" style={{color:(viewMode == ViewModes.CLIENT)?'#01717C':'#1C2E4599'}}>{intl.formatMessage({id:'Client'})}</span>
                        </a>
                    </li>}
                    <li style={{backgroundColor:'#f9fafb'}}>
                        <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 border-noround', { 'tabComponent': viewMode == ViewModes.BUSINESS, ' text-700 border-transparent': viewMode != ViewModes.BUSINESS })} onClick={() => setViewMode(ViewModes.BUSINESS)}>
                            <span className="font-medium" style={{color:(viewMode == ViewModes.BUSINESS)?'#01717C':'#1C2E4599'}}>{intl.formatMessage({id:'Enterprise'})}</span>
                        </a>
                    </li>
                </ul>
                <ButtonOverlay buttonClassName="button-grey p-button-rounded">
                    <div className="flex flex-column">
                        <TableButton
                            icon="pi pi-pencil"
                            iconPos="left"
                            label={intl.formatMessage({ id: 'Edit' })}
                            className={`text-left TableButtonStyle  my-1 p-1`}
                            onClick={() => setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.EDIT])}
                        />
                        {/* {<TableButton
                            icon="pi pi-send"
                            iconPos="left"
                            label={intl.formatMessage({ id: 'SendByEmail' })}
                            className={`text-left TableButtonStyle  my-1 p-1`}
                            onClick={() => setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.SENDBYEMAIL])}
                        />} */}
                        <TableButton
                            icon="pi pi-clone"
                            iconPos="left"
                            label={intl.formatMessage({ id: 'Duplicate' })}
                            className={`text-left TableButtonStyle  my-1 p-1`}
                            onClick={() => {
                                setOpenDuplicateBudgetModal(true);
                            }}
                        />
                        {selectedBudget.budgetstate == 3 && <TableButton
                            icon="pi pi-dollar"
                            iconPos="left"
                            label={"Generar orden"}
                            className={`text-left TableButtonStyle  my-1 p-1`}
                            onClick={() => {
                                setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE])
                            }}/>}
                        {<TableButton
                            icon="pi pi-download"
                            iconPos="left"
                            label={"Descargar PDF"}
                            className={`text-left TableButtonStyle  my-1 p-1`}
                            onClick={() => {
                                setOpenPrintBudgetModal(true);
                            }}
                        />} 
                    </div>
                </ButtonOverlay>
            </div>
            {/* <Divider className="my-2"></Divider>  A mi no me funciono (no se visualiza) si logras que se vea, agregalo como divider*/}
            <div className="p-mb-2 p-mt-2" style={{background: 'rgba(26, 56, 96, 0.1)', height: '1px',marginBottom:'13px'}}></div>

            <div className={`flex w-full`} style={{background: '#1A38601A'}}>
                <p key={1} className={`flex ml-2 py-3 w-1/6 font-medium `}>{formatDate(getDate(selectedBudget.date))}</p>
                <p key={2} className={`flex py-3 w-2/6 font-medium `}>{`N° ${selectedBudget.budget ?? 'XXX'} - ${selectedBudget.agreementdesc  ?? 'XXX'}`}</p>
                <p key={3} className={`flex py-3 font-bold text-center text-2xl w-auto`}>{selectedBudget.addressee}</p>
            </div>
            <div className={`flex w-full`}>
                <p key={1} className={`flex ml-2 py-3 w-1/6 font-medium `}>{`${selectedBudget.duration ?? 'XXX'} Días`}</p>
                <p key={2} className={`flex py-3 w-2/6 font-medium `}>{selectedBudget.detail ?? '-'}</p>
            </div>

            <Combobox label={"Estado"} 
                className={`input-common w-1/4`} 
                getItems={getBudgetStates}
                optionLabel='name' 
                placeholder="Seleccionar"
                value={selectedBudget.budgetstatedescription}
                setValue={(e:ComboDataDTO) => {
                        setSelectedBudget({ ...selectedBudget, budgetstate: e.id, budgetstatedescription: e.name});
                        changeBudgetState(selectedBudget.budget??0, e.id??0);
                    }
                } 
            />

            <BudgetTable budget={selectedBudget} defaultEarnings={0} CRUDBehaviour={false} showSurcharge={viewMode == ViewModes.BUSINESS}/>

            <div className="flex flex-row justify-content-start align-middle mt-4">
                <p className="font-bold">{`${intl.formatMessage({id:'Observations'})}:`}</p>&nbsp;
                <p>{`${selectedBudget.observations}`}</p>
            </div>

            <DuplicateBudgetModal openDuplicateBudgetModal={openDuplicateBudgetModal} setOpenDuplicateBudgetModal={setOpenDuplicateBudgetModal} budgetId={selectedBudget.budget??0} onDuplicateBudget={onDuplicateBudget}/>
        </div>
    )
}
